module.exports = __webpack_public_path__ + "static/media/legal-jobs-2.0a0b6417.png";